import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { Animal, getAnimalLabel } from 'src/app/_enums/animal/animal.enum';
import { CatType, getCatTypeLabel } from 'src/app/_enums/animal/cat-type.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { getAnimalSexEnumLabel, SexEnum } from 'src/app/_enums/sex.enum';
import { DOG_RACES } from 'src/app/_services/constants/dog-races';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-animal-form',
  templateUrl: './animal-form.component.html',
  styleUrls: ['./animal-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class AnimalFormComponent
  extends LeadFormBase
  implements OnDestroy, OnInit
{
  @Input()
  formGroup!: FormGroup;

  immediateInsuranceSubscription!: Subscription;

  animalTypeSubscription!: Subscription;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.ANIMAL,
    animalType: [null],
    dogRace: [null],
    catType: [null],
    deductibleValue: [null],
    isImmediateInsuranceStart: [null],
    insuranceStartDate: [null],
    sex: [null],
    name: [null],
    birthDate: [null],
    color: [null],
    catRace: [null],
    chipNumber: [null],
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) this.metadataFormGroup.patchValue(this.metadata);
    this.formGroup.addControl('metadata', this.metadataFormGroup);
    this.immediateInsuranceSubscription = this.metadataFormGroup.controls[
      'isImmediateInsuranceStart'
    ].valueChanges.subscribe((value) => {
      if (value) {
        this.metadataFormGroup.controls['insuranceStartDate'].reset();
      }
    });

    this.animalTypeSubscription = this.metadataFormGroup.controls[
      'animalType'
    ].valueChanges.subscribe((value) => {
      if (value === Animal.DOG) {
        this.metadataFormGroup.controls['catType'].reset();
        this.metadataFormGroup.controls['catRace'].reset();
      }
      if (value === Animal.CAT) {
        this.metadataFormGroup.controls['dogRace'].reset();
      }
    });
  }

  ngOnDestroy(): void {
    this.immediateInsuranceSubscription.unsubscribe();
    this.animalTypeSubscription.unsubscribe();
  }

  catTypeValues = Object.values(CatType);

  getCatTypeLabel = getCatTypeLabel;

  sexValues = [SexEnum.MALE, SexEnum.FEMALE];

  getSexEnumLabel = getAnimalSexEnumLabel;

  animalValues = Object.values(Animal);

  getAnimalLabel = getAnimalLabel;

  dogRaces = DOG_RACES;

  Animal = Animal;
}
